export class RequisitionLine {
    id:number = 0;
    requisition_id:number = 0;
    article_id:number = 0;
    supplier_id:number = null;
    supplier_name:string = null;
    article_name:string = '';
    description:string = '';
    quantity:number = 0;
    missing_quantity:number = 0;
    unit_price:number = 0;
    iva:number = 0.16;
    unity_id:number = null;
    unity:string = '';
    unity_chassis_serial_num:string = '';
    unity_engine_serial_num:string = '';
    unity_serial_num:string = '';
    status:string = 'Creada';
    selected:boolean = false;
    measure_unit:string = 'pza';
    customer_id:number = 0;
    customer_name:string = '';
    warehouse_measure_unit:string = '';
    warehouse_factor:number = 1;
    is_sap:boolean = false;
    item_code_sap:string = '';
    item_name_sap:string = '';
    comments:string = '';
}
